import gql from 'graphql-tag';

export default gql`
  mutation signUpArtist(
    $agency: String
    $email: String!
    $password: String!
    $name: String!
    $lastname: String!
    $birthday: String!
    $nationality: String!
    $residence: String!
    $profession: String!
    $specialty: String!
    $biography: String!
    $images: [UserImageInput]
  ) {
    signUpArtist(
      agency: $agency
      email: $email
      password: $password
      name: $name
      lastname: $lastname
      birthday: $birthday
      nationality: $nationality
      residence: $residence
      profession: $profession
      specialty: $specialty
      biography: $biography
      images: $images
    ) {
      token
      user {
        id
        name
        type
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/SignUp.js